export namespace ExecutionPlatform {
  export const LYFT = 'LYFT';
  export const UZURV360 = 'UZURV360';
}
